<template>
  <el-container class="header_container">
    <el-header>
      <div class="left">
        <router-link :to="{ path: '/' }">
          <img :src="require('@/assets/images/xsy.png')" alt="闪销云" width="78" height="28">
        </router-link>
        <!-- <el-radio-group v-model="isCollapse" @change="handleOpen">
          <el-radio-button v-if="is_close" size="mini" class="my_open_btn" :label="true"> <i class="el-icon-s-fold"></i>
          </el-radio-button>
          <el-radio-button v-if="is_open" size="mini" class="my_open_btn" :label="false"> <i
              class="el-icon-s-unfold"></i>
          </el-radio-button>
        </el-radio-group> -->
      </div>
      <div class="right">
        <span>{{ AdminId }}</span>
        <el-dropdown>
          <i class="el-icon-setting" style="margin-right: 15px"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="loginOut()">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container>
      <!-- background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" -->
      <el-menu :router="true" :collapse="isCollapse" unique-opened class="el-menu-vertical-demo" @select="selectMenu">
        <el-menu-item v-for="(item, index) in menuList" :key="index" :index="item.id + '-' + item.name" :route="item.url">
          {{ item.name }}</el-menu-item>
      </el-menu>
      <keep-alive v-if="$route.meta.keepAlive">
        <router-view></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </el-container>
  </el-container>
</template>

<script>
import {
  signOut
} from '@/api.js'
import {
  mapState
} from 'vuex'

export default {
  name: "CompanyIndex",
  data() {
    return {
      nickName: this.nickName,
      isCollapse: false,
      is_open: false,
      is_close: true,
      menuList: [{
        children: [],
        icon: "",
        id: 18,
        name: "首页",
        url: "/"
      }, {
        children: [],
        icon: "",
        id: 18,
        name: "企业信息",
        url: "/company/basic_info"
      }, {
        children: [],
        icon: "",
        id: 18,
        name: "企业认证",
        url: "/company/attestation"
      }, {
        children: [],
        icon: "",
        id: 18,
        name: "当前服务",
        url: "/company/current_service"
      }, {
        children: [],
        icon: "",
        id: 18,
        name: "发票管理",
        url: "/company/invoice_management"
      }, {
        children: [],
        icon: "",
        id: 18,
        name: "抬头管理",
        url: "/company/header_management"
      }, {
        children: [],
        icon: "",
        id: 18,
        name: "邮寄地址",
        url: "/company/address_management"
      }, {
        children: [],
        icon: "",
        id: 18,
        name: "购买记录",
        url: "/company/purchase_record"
      }, {
        children: [],
        icon: "",
        id: 18,
        name: "账号信息",
        url: "/company/personal_info"
      }, {
        children: [],
        icon: "",
        id: 18,
        name: "账号权限",
        url: "/company/account_management"
      }]
    }
  },
  mounted() {
    this.$store.commit("refreshMenuList", this.menuList);
    console.log(this.menuList)
  },
  methods: {
    // 退出登录
    loginOut() {
      signOut().then(res => {
        if (res.code == 0) {
          this.$router.push({
            path: '/login',
          })
          this.$store.commit('refreshAccessToken', '')
          this.$store.commit('refreshActiveMenu', '')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 菜单切换
    selectMenu(index, indexPath) {
      this.$store.commit('refreshIndexPath', indexPath)
      console.log(index, indexPath)
    },
    // 菜单栏伸缩
    handleOpen() {
      if (this.isCollapse) {
        this.is_open = true
        this.is_close = false
      } else {
        this.is_open = false
        this.is_close = true
      }
    },
  },
  computed: {
    ...mapState({
      access_token: state => state.access_token,
      baseUrl: state => state.baseUrl,
      menuList: state => state.menuList,
      nickName: state => state.nickName,
      AdminId: state => state.AdminId,
    }),
  },
}
</script>

<style scoped lang="scss">
.header_container {
  height: 100%;

  .el-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    position: relative;
    background-color: rgb(245, 250, 255);
    line-height: 60px;
    padding: 0 25px;

    .left {
      img {
        vertical-align: middle;
        margin-right: 60px;
      }
    }

    .el-dropdown {
      // color: #fff;
      margin-left: 20px;
    }
  }

  .el-menu {
    width: 200px;
    text-align: center;
    background: linear-gradient(180deg, #E7EFFE 0%, #FFFFFF 100%, #FFFFFF 100%);
  }
}
</style>